import { jotaiStore } from "../../utils/jotaiStore";
import { DevTools } from "jotai-devtools";
import { useAtomValue } from "jotai";
import "jotai-devtools/styles.css";
import { darkModeAtom } from "../../atoms/user/darkModeAtom";
import { showJotaiDevToolsAtom } from "../../atoms/dev/jotaiDevtoolsAtom";

export const JotaiDevToolsProvider = () => {
  const darkMode = useAtomValue(darkModeAtom);
  const showJotaiDevTools = useAtomValue(showJotaiDevToolsAtom);
  return (
    showJotaiDevTools && (
      <DevTools
        position={"top-left"}
        store={jotaiStore}
        theme={darkMode ? "dark" : "light"}
      />
    )
  );
};
